export default __webpack_public_path__ + "static/media/bigLogo.f929968b.svg";